/** デバイス台帳・右パネル・詳細で共通に使う小さな表示(札・利用者・OS 文字列)。 */
import { Tag, Typography } from "antd";
import { Link } from "react-router-dom";

import type { Device } from "../../lib/api";
import { StatusTag } from "../../ui";
import { deviceStatusTone, policyStateTone, sourceColor, sourceLabel } from "./constants";

/** 取得元は分類なので antd Tag(状態ではない)。 */
export function sourceTag(v: string) {
  return <Tag color={sourceColor(v)}>{sourceLabel(v)}</Tag>;
}

/** iPhone / iPad は OS 名が Mac と紛らわしいので、一目で分かる札を付ける。 */
export function mobileBadge(os: string | null | undefined): string | null {
  if (!os) return null;
  if (os.startsWith("iOS")) return "iPhone";
  if (os.startsWith("iPadOS")) return "iPad";
  return null;
}

export function platformTag(os: string | null | undefined) {
  const badge = mobileBadge(os);
  return badge ? (
    <Tag color="purple" data-testid="device-platform">
      {badge}
    </Tag>
  ) : null;
}

export function osText(d: Pick<Device, "os" | "os_version">): string {
  return [d.os, d.os_version].filter(Boolean).join(" ");
}

/** 利用者。従業員に紐づいていれば従業員詳細へのリンク、メールだけなら素の文字。 */
export function userCell(
  d: Pick<Device, "employee_id" | "employee_name" | "employee_email"> & { employee_confirmed?: boolean },
) {
  if (d.employee_id)
    return (
      <span>
        <Link to={`/hr/employees/${d.employee_id}`}>{d.employee_name}</Link>{" "}
        <Typography.Text type="secondary">{d.employee_email}</Typography.Text>
        {d.employee_confirmed === false && (
          <Typography.Text type="warning" style={{ fontSize: 12 }}>
            {" "}
            自己申告(グループ指定には使わない。利用者を確定すると当たる)
          </Typography.Text>
        )}
      </span>
    );
  return d.employee_email || "";
}

/** ポリシー適用の進み(N / M)。 */
export function policyProgress(d: Pick<Device, "policy_applied" | "policy_total">) {
  if (!d.policy_total) return "";
  return (
    <StatusTag tone={deviceStatusTone(d.policy_applied, d.policy_total)} dot>
      <span className="ui-num">
        {d.policy_applied} / {d.policy_total}
      </span>
    </StatusTag>
  );
}

/** ポリシー 1 件の適用結果(`key: state`)。 */
export function policyStateTag(key: string, state: string) {
  return (
    <StatusTag key={key} tone={policyStateTone(state)} dot>
      {key}: {state}
    </StatusTag>
  );
}
